import React from "react";
import rumahmilenial from "./rumahmilenial.json";
import "./rumahmilenial.scss";
import Cardrumah from "../../../component/cardrumah/cardrumah.jsx";
import mileniala from "../../../asset/rumahmilenial/a/mileniala.js";
import milenialb from "../../../asset/rumahmilenial/b/milenialb.js";
import milenialc from "../../../asset/rumahmilenial/c/milenialc.js";
const imageMap = {
  mileniala,
  milenialb,
  milenialc,

  // Add other image arrays here if you have more sets
};

const Rumahmilenial = () => {
  return (
    <div className="rumahmilenial">
      <div className="container-rumahmilenial">
        <div className="header">
          <div className="judul-rumahmilenial">
            <div className="pink"></div>
            <span>
              Rumah Milenial <b>(SIAP HUNI)</b>{" "}
            </span>
          </div>
        </div>
        <div className="cardhome-container">
          {rumahmilenial.cards.map((card, index) => {
            // Determine the logo dynamically
            return (
              <Cardrumah
                key={index}
                carousel={imageMap[card.imagesKey]}
                title={card.title}
                subtitle={card.subtitle}
                price={card.price}
                subprice={card.subprice}
                details={card.details}
                whatsappLink={card.whatsappLink} // Pass the WhatsApp link
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Rumahmilenial;
